import React, { useMemo } from 'react';
import { TDataInterface, TMaterialTableColumns } from './index.types';
import MaterialTableRow from '@material-ui/core/TableRow';
import TableCell from './table-cell';

const TableRow = <T extends TDataInterface>({
    columns,
    rowData,
    rowKey,
    onClickRow,
}: {
    columns: TMaterialTableColumns<T>;
    rowData: T;
    rowKey: string;
    onClickRow?: (value?: any) => void;
}) => {
    const retData = useMemo(
        () =>
            columns &&
            Array.isArray(columns) &&
            columns.map((value) => {
                const cellValue =
                    value.key && value.key in rowData
                        ? rowData[value.key]
                        : null;

                if (!cellValue && !value.render) {
                    /*
                    console.debug(
                        'No cell value (key of row data) nor render function is set for table cell',
                    );
                   */
                }

                const handleClick = (): void | null => {
                    return onClickRow ? onClickRow(rowData) : null;
                };

                return (
                    <TableCell
                        key={value.title}
                        cellValue={cellValue}
                        value={value}
                        rowData={rowData}
                        onClickCell={
                            value.key !== 'checkbox' ? handleClick : undefined
                        }
                    />
                );
            }),
        [columns, rowData, onClickRow],
    );
    return <MaterialTableRow key={rowKey}>{retData}</MaterialTableRow>;
};

export default TableRow;
